// src/components/Navbar.js
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Navbar() {
  const { logout } = useAuth();
  const location = useLocation();
  const { user } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-white shadow-sm border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <h1 className="text-xl font-bold text-gray-900">QuizTech</h1>
            {/* Menu desktop */}
            <div className="hidden md:flex md:items-center md:ml-6 space-x-1">
              <Link
                to="/dashboard"
                className={`px-2 py-1.5 rounded-md text-sm font-medium ${
                  isActive('/dashboard')
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                <span className="hidden md:inline">Accueil</span>
                <span className="md:hidden">A</span>
              </Link>
              <Link
                to="/questions"
                className={`px-2 py-1.5 rounded-md text-sm font-medium ${
                  isActive('/questions')
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                <span className="hidden md:inline">Questions</span>
                <span className="md:hidden">Q</span>
              </Link>
              <Link
                to="/formations"
                className={`inline-flex items-center gap-1.5 px-2 py-1.5 rounded-md text-sm font-medium ${
                  isActive('/formations')
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                <span className="hidden md:inline">Formations</span>
                <span className="md:hidden">F</span>
                <span className="hidden md:inline text-[10px] font-bold bg-green-100 text-green-700 px-1.5 py-0.5 rounded-full leading-none">Nouveau</span>
              </Link>
              <Link
                to="/domaines-expertise"
                className={`px-2 py-1.5 rounded-md text-sm font-medium ${
                  isActive('/domaines-expertise')
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                <span className="hidden md:inline">Modules</span>
                <span className="md:hidden">M</span>
              </Link>
              <Link
                to="/plateformes"
                className={`px-2 py-1.5 rounded-md text-sm font-medium ${
                  isActive('/plateformes')
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                <span className="hidden md:inline">Plateformes</span>
                <span className="md:hidden">P</span>
              </Link>
              <Link
                to="/ressources"
                className={`inline-flex items-center gap-1.5 px-2 py-1.5 rounded-md text-sm font-medium ${
                  isActive('/ressources')
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                <span className="hidden md:inline">Ressources</span>
                <span className="md:hidden">R</span>
                <span className="hidden md:inline text-[10px] font-bold bg-green-100 text-green-700 px-1.5 py-0.5 rounded-full leading-none">Nouveau</span>
              </Link>
              <Link
                to="/import-questions"
                className={`px-2 py-1.5 rounded-md text-sm font-medium ${
                  isActive('/import-questions')
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                <span className="hidden md:inline">Importer</span>
                <span className="md:hidden">I</span>
              </Link>
              <Link
                to="/export-questions"
                className={`px-2 py-1.5 rounded-md text-sm font-medium ${
                  isActive('/export-questions')
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                <span className="hidden md:inline">Exporter</span>
                <span className="md:hidden">E</span>
              </Link>
              {user?.role === 'admin' && (
                <Link
                  to="/users"
                  className={`px-2 py-1.5 rounded-md text-sm font-medium ${
                    isActive('/users')
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  <span className="hidden md:inline">Utilisateurs</span>
                  <span className="md:hidden">U</span>
                </Link>
              )}
            </div>
          </div>
          
          {/* Menu mobile button */}
          <div className="flex md:hidden items-center">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 focus:outline-none"
            >
              <span className="sr-only">Ouvrir menu</span>
              {!mobileMenuOpen ? (
                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              ) : (
                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              )}
            </button>
          </div>
          
          <div className="hidden md:flex items-center">
            <span className="text-sm text-gray-500 mr-2">Bonjour,</span>
            <span className="text-sm text-gray-500 mr-4 truncate max-w-[150px]">{user?.email}</span>
            <button
              onClick={logout}
              className="bg-red-600 hover:bg-red-700 text-white px-3 py-1.5 rounded-md text-sm font-medium transition"
            >
              Déconnexion
            </button>
          </div>
        </div>
        
        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="md:hidden">
            <div className="pt-2 pb-3 space-y-1">
              <Link
                to="/dashboard"
                className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium rounded-md ${
                  isActive('/dashboard')
                    ? 'bg-blue-50 border-blue-500 text-blue-700'
                    : 'border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Accueil
              </Link>
              <Link
                to="/questions"
                className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium rounded-md ${
                  isActive('/questions')
                    ? 'bg-blue-50 border-blue-500 text-blue-700'
                    : 'border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Questions
              </Link>
              <Link
                to="/formations"
                className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium rounded-md ${
                  isActive('/formations')
                    ? 'bg-blue-50 border-blue-500 text-blue-700'
                    : 'border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Formations
              </Link>
              <Link
                to="/domaines-expertise"
                className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium rounded-md ${
                  isActive('/domaines-expertise')
                    ? 'bg-blue-50 border-blue-500 text-blue-700'
                    : 'border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Modules
              </Link>
              <Link
                to="/plateformes"
                className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium rounded-md ${
                  isActive('/plateformes')
                    ? 'bg-blue-50 border-blue-500 text-blue-700'
                    : 'border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Plateformes
              </Link>
              <Link
                to="/ressources"
                className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium rounded-md ${
                  isActive('/ressources')
                    ? 'bg-blue-50 border-blue-500 text-blue-700'
                    : 'border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Ressources
              </Link>
              <Link
                to="/import-questions"
                className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium rounded-md ${
                  isActive('/import-questions')
                    ? 'bg-blue-50 border-blue-500 text-blue-700'
                    : 'border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Importer
              </Link>
              <Link
                to="/export-questions"
                className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium rounded-md ${
                  isActive('/export-questions')
                    ? 'bg-blue-50 border-blue-500 text-blue-700'
                    : 'border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Exporter
              </Link>
              {user?.role === 'admin' && (
                <Link
                  to="/users"
                  className={`block pl-3 pr-4 py-2 border-l-4 text-base font-medium rounded-md ${
                    isActive('/users')
                      ? 'bg-blue-50 border-blue-500 text-blue-700'
                      : 'border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800'
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Utilisateurs
                </Link>
              )}
              <button
                onClick={logout}
                className="block w-full text-left pl-3 pr-4 py-2 text-base font-medium text-red-600 hover:bg-red-50 rounded-md"
              >
                Déconnexion
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;